import merge from 'lodash/merge';
import { Dimensions, StyleSheet } from 'react-native';
import { lottieConfig } from '../../constants';
import { checkIsPlatform } from '../../utils';
export var getLottieStyles = props => {
  var height = props.height,
    width = props.width;
  var position = checkIsPlatform('web') ? 'fixed' : 'absolute';
  return StyleSheet.create({
    container: {
      height,
      width
    },
    showAsFullPage: {
      height: Dimensions.get('window').height,
      width: Dimensions.get('window').width,
      position,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 99999
    }
  });
};
export var getLottieProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(lottieConfig === null || lottieConfig === void 0 ? void 0 : lottieConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.lottie) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};